<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="list-of-characters">
<h1>List of Characters</h1>
<p style="text-align: center; margin-top:-50px;">*Fictional Character</p>
<br/><br/>
<p>AKECHI HIDEMITSU: Samurai retainer to Akechi Mitsuhide.</p>
<p>AKECHI MITSUHIDE: Daimyo &amp; vassal of Oda Nobunaga.</p>
<p>AKECHI SAMA: Samurai retainer to Akechi Mitsuhide.</p>
<p>ANAYAMA NOBUTADA: Samurai retainer of Tokugawa Ieyasu.</p>
<p>ARAKI MURASHIGE: Samurai retainer of Oda Nobunaga.</p>
<p>AZAI HISAMASA: Father of Azai Lord Nagamasa.</p>
<p>AZAI NAGAMASA: Daimyo of Omi province and brother-in-law to Nobunaga. Husband of Oichi.</p>
<p>FUJITA DENGO: Samurai retainer to Akechi Mitsuhide.</p>
<p>HAJIKANO MASATSUGU: General of Takeda Shingen, Sakichi’s alleged father.</p>
<p>HATANO HIDEHARU: Head of the Hatano clan and retainer of Lord Miyoshi.</p>
<p>HATTORI HANZO: Retainer to Tokugawa Ieyasu.</p>
<p>HAYASHI HIDESADA: Samurai retainer of Oda Nobunaga.</p>
<p>HIDEYOSHI: Retainer to Nobunaga. Originally known as Kinoshita Tokichiro, then took the name Hashiba Hideyoshi.</p>
<p>HIROKOHIME: Principal wife of Akechi Mitsuhide.</p>
<p>HOJO MASAKO: Wife to Takeda Katsuyori, son of Takeda Shingen.</p>
<p>HOJO UJIYASU: Daimyo of Sagami province.</p>
<p>HONDA TADAKATSU: Samurai retainer of Tokugawa Ieyasu.</p>
<p>HOSOKAWA FUJITAKA: Advisor to Shogun Yoshiaki.</p>
<p>IMAI SOKYU: Noted tea Master and Sakai merchant.</p>
<p>ISHIDA MASATSUGU: Sakichi’s adoptive father.</p>
<p>ISHIDA MASAZUMI: Eldest son of Ishida Masatsugu, Sakichi’s stepbrother.</p>
<p>KENSHO-IN: A daughter of Takeda Shingen.</p>
<p>KUNITOMO ZENBEE: A Kunitomo Sword smith.</p>
<p>MASTER IGARASHI: Lacquer ware artisan in Kyoto.</p>
<p>MIKO*: Childhood friend of Sakichi.</p>
<p>MOCHIZUKI CHIYO: Female Kunoichi (Shinobi/Ninja) leader. Agent for the Takeda clan.</p>
<p>MORI TERUMOTO: Daimyo and Mori clan leader, an enemy of Nobunaga.</p>
<p>NAO*: Courtesan.</p>
<p>NENE: Hideyoshi’s wife.</p>
<p>OBAI-IN: A daughter of Takeda Shingen.</p>
<p>ODA NOBUKATSU: Second son of Nobunaga.</p>
<p>ODA NOBUNAGA: Daimyo, Warlord &amp; the first ‘Great Unifier’ of Japan.</p>
<p>ODA NOBUTADA: Eldest son of Nobunaga.</p>
<p>OICHI: Wife to Azai Nagamasa and sister to Nobunaga.</p>
<p>OKO*: Childhood friend of Sakichi.</p>
<p>OKUBO TADAYO: Samurai retainer of Tokugawa Ieyasu.</p>
<p>ONA*: Courtesan in training.</p>
<p>SADAKO: Wife of Ishida Masatsugu and adoptive mother of Sakichi.</p>
<p>SAITO KURA: Samurai retainer to Akechi Mitsuhide.</p>
<p>SAITO TANEOMI: A Sakamoto pottery merchant.</p>
<p>SAKAI TADATSUGU: Samurai retainer of Tokugawa Ieyasu.</p>
<p>SAKICHI: Boyhood name of Ishida Mitsunari.</p>
<p>SANADA YUKITAKA: One of Takeda Shingen’s twenty-four generals.</p>
<p>SHIBATA KATSUIE: Samurai retainer of Oda Nobunaga.</p>
<p>SHIZEN: Akechi Mitsuhide’s daughter from his concubine.</p>
<p>TAKEDA KATSUYORI: Son of Takeda Shingen by concubine Suwa Goryonin.</p>
<p>TAKEDA SHINGEN: Pre-eminent Daimyo of Kai province. Also known as Harunobu.</p>
<p>TAMA: Akechi Mitsuhide’s daughter from Hirokohime.</p>
<p>TANAKA YOSHIMASA: Samurai. Also known as Atsuji Sadahide in a past life.</p>
<p>TOKUGAWA IEYASU: Daimyo of Mikawa province and ally of Nobunaga.</p>
<p>TOKYUSAEMON: A Kunitomo blacksmith.</p>
<p>TOMO SUKESADA: A <em>jonin</em> (master ninja) of the Koga Ninja clan.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?5c88cab4